module.exports = __webpack_public_path__ + "img/unpakt.19ff8cd0.png";